import React, { useState, useEffect } from 'react';

import { ToggleSwitch } from '../../toggle-switch';
import LiveCardLatestNewsVideos from './live-card-latest-news-videos';
import LiveCardLatestNewsArticles from './live-card-latest-news-articles';

const LiveCardLatestNews = (props) => {
    const {
        videosData, articlesData, loadMoreVideosUrl, loadMoreArticlesUrl, tabs,
        viewMoreVideosText, viewMoreArticlesText
    } = props;

    const videosContentItems = videosData && videosData.contentItems ? videosData.contentItems : [];
    const articlesContentItems = articlesData && articlesData.items ? articlesData.items : [];

    const hasVideos = videosContentItems.length > 0;
    const hasArticles = articlesContentItems.length > 0;

    const videoTab = tabs.find((tab) => tab.id === 'videos');
    const articlesTab = tabs.find((tab) => tab.id === 'articles');

    const leftLabel = videoTab ? videoTab.text : 'Videos';
    const rightLabel = articlesTab ? articlesTab.text : 'Articles';

    const [selectedTab, setSelectedTab] = useState(
        hasVideos ? 'videos' : 'articles'
    );

    useEffect(() => {
        if (!hasVideos && hasArticles) {
            setSelectedTab('articles');
        } else if (hasVideos && !hasArticles) {
            setSelectedTab('videos');
        }
    }, [hasVideos, hasArticles]);

    return (
        <div className="live-card-latest-news">
            {hasVideos && hasArticles && (
                <ToggleSwitch
                    leftLabel={leftLabel}
                    rightLabel={rightLabel}
                    selected={selectedTab === 'videos' ? 'left' : 'right'}
                    onToggle={() =>
                        setSelectedTab(selectedTab === 'videos' ? 'articles' : 'videos')
                    }
                />
            )}

            <div className="live-card-latest-news__content">
                {selectedTab === 'videos' && hasVideos && (
                    <LiveCardLatestNewsVideos
                        contentItems={videosContentItems}
                        loadMoreVideosUrl={loadMoreVideosUrl}
                        viewMoreVideosText={viewMoreVideosText}
                    />
                )}
                {selectedTab === 'articles' && hasArticles && (
                    <LiveCardLatestNewsArticles
                        contentItems={articlesContentItems}
                        loadMoreArticlesUrl={loadMoreArticlesUrl}
                        viewMoreArticlesText={viewMoreArticlesText}
                    />
                )}
            </div>
        </div>
    );
};

export default LiveCardLatestNews;
